import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TransportationService } from "../../../services/transportation.service";
import swal from "sweetalert2";
import { CitaService } from "../../../services/cita.service";
import { UserService } from "../../../services/user.service";
import { Methods } from "../../../shared/methods";

declare const $: any;

@Component({
  selector: "app-transportation-details",
  templateUrl: "./transportation-details.component.html",
  styleUrls: ["./transportation-details.component.css"],
  providers: [TransportationService, CitaService, UserService],
})
export class TransportationDetailsComponent implements OnInit {
  public mtds: Methods = new Methods();
  @Input() trackingInfo: string = "";
  @Input() po_id: number;
  @Input() tableTrakings: string[][] = [];
  public tracking = "";
  public inidates: [];
  public trackingNumber = "";
  public proNumber = "";
  public smallParcelCarrier = "";
  public freightCarrier = "";
  public expectedDate: any;
  public expectedDateOld = "";
  public initialDate = "";
  public GTSTruck = "";
  public type = "";
  public GTSDriver = "";
  public editId = null;
  public pickups = null;
  public token;
  public editTracking = false;
  public saving: boolean;
  public editDate: boolean = false;
  public hasbuttons: boolean = false;
  public idarray = [];

  constructor(
    private _transpSservice: TransportationService,
    private _citaService: CitaService,
    private _userService: UserService
  ) {
    this.token = this._userService.getToken();
  }

  ngOnInit() {
    this.showTransportationDetails();
    this.showPickupDetail();
  }

  addTracking() {
    this.saving = true;
    let data = {
      po_id: this.po_id,
      expectedDate: this.expectedDate,
      trackingNumber: this.trackingNumber,
      proNumber: this.proNumber,
      comments: "",
      type: this.trackingInfo,
      freightCarrier: this.freightCarrier,
      smallParcerCarrier: this.smallParcelCarrier,
    };

    this._transpSservice.create(data).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showTransportationDetails();
          this.showPickupDetail();
          this.initTrackingData();
          setTimeout(() => {
            this.showSwal("success", `Tracking information has been added`);
          }, 1500);
          // this.buscandoTrakings = true
        } else {
          alert("Error!");
        }
        this.saving = false;
      },
      (error) => {
        alert("Error!");
        this.saving = false;
      }
    );
  }
  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
     
        title: title,
        text: message,
        buttonsStyling: false,
        
 customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    } else if (type === "error") {
      swal.fire({
    
        title: "ERROR!",
        text: "An error has ocurred.",
        buttonsStyling: false,
        
 customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    }
  }

  showPickupDetail() {
    this._citaService.getListByPO(this.token, this.po_id).subscribe((r) => {
      if (r.status === "success" && r.data.length > 0) {
        this.pickups = r.data;
        r.data.forEach(
          function (element) {
            let arrayhr = element.horaCita.split(":");
            let seconds = +arrayhr[0] * 60 * 60 + +arrayhr[1] * 60;
            seconds = seconds * 1000;
            let pickUpDate = element.fechaCita.timestamp * 1000;
            pickUpDate = pickUpDate + seconds;
            this.haspickup = true;

            this.tableTrakings.push([
              element.id,
              element.type,
              element.masterCompany.name,
              "N/A",
              "N/A",
              "N/A",
              this.mtds.getFecha(new Date(pickUpDate), "MM-dd-yyyy"),
              false,
            ]);
          }.bind(this)
        );
      }
    });
  }

  showTransportationDetails() {
    this.tableTrakings = [];
    this._transpSservice.showAll(this.po_id).subscribe((response) => {
      response.data.forEach(
        function (element) {
          if (element) {
            this.tableTrakings.push([
              element.id,
              element.type,
              element.freightCarrier,
              element.smallParcerCarrier,
              element.proNumber,
              element.trackingNumber,
              this.convertDate(
                element.expectedDate
                  ? element.expectedDate
                  : this.mtds.getFecha(new Date(element.createdAt.timestamp)),
                "mm-dd-yyyy"
              ),
              true,
            ]);
          }
        }.bind(this)
      );
      let ids = this.tableTrakings.map((x) => x[0]);
      this.idarray = ids;
    });
  }
  removeTracking() {
    for (const id of this.idarray) {
      this.editId = id
      this.deleteTraking()
    }
  }
  initTrackingData() {
    (this.expectedDate = ""),
      (this.trackingNumber = ""),
      (this.proNumber = ""),
      (this.trackingInfo = ""),
      (this.freightCarrier = ""),
      (this.smallParcelCarrier = "");
    this.editTracking = false;
    this.editDate = false;
  }
  deleteTraking() {
    this.saving = true;

    this._transpSservice.delete(this.editId).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showTransportationDetails();
          this.showPickupDetail();
          this.initTrackingData();
          this.showSwal("success", "Tracking information has been deleted");
        } else {
          alert("Error!");
        }
        this.saving = false;
      },
      (error) => {
        alert("Error!");
        this.saving = false;
      }
    );
    this.closeDeleteModal();
  }
  actions(e) {
    this.editId = e.id;
    console.log(e.id, "id");
    switch (e.evento) {
      case "show": {
        this.trackingInfo = e.row[1];
        (this.freightCarrier = e.row[2]),
          (this.smallParcelCarrier = e.row[3]),
          (this.proNumber = e.row[4]),
          (this.trackingNumber = e.row[5]);
        this.expectedDate = this.convertDate(e.row[6], "yyyy-mm-dd");
        this.editTracking = true;
        if (this.editTracking == true) {
          document.getElementById("targetBlue").scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
        break;
      }
      case "delete": {
        this.deleteModal();
        break;
      }
    }
  }
  updateTracking() {
    this.editId;

    const data = {
      po_id: this.po_id,
      expectedDate: this.expectedDate
        ? this.expectedDate
        : this.convertDate(this.expectedDateOld, "yyyy-mm-dd"),
      trackingNumber: this.trackingNumber,
      proNumber: this.proNumber,
      comments: "",
      type: this.trackingInfo,
      freightCarrier: this.freightCarrier,
      smallParcerCarrier: this.smallParcelCarrier,
    };
    this._transpSservice.update(data, this.editId).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showTransportationDetails();
          this.showPickupDetail();
          this.initTrackingData();
          this.showSwal("success", `Tracking information has been updated`);
        } else {
          alert("Error!");
        }
        this.saving = false;
      },
      (error) => {
        alert("Error!");
        this.saving = false;
      }
    );
  }
  deleteModal() {
    $(".modal-delete").show();
  }
  closeDeleteModal() {
    $(".modal-delete").hide();
  }
  convertDate(date, format) {
    let dateSplitted = date.split("-");
    let year;
    let month;
    let day;
    if (format == "mm-dd-yyyy") {
      year = dateSplitted[0];
      month = dateSplitted[1];
      day = dateSplitted[2];
      return `${month}-${day}-${year}`;
    } else if (format == "yyyy-mm-dd") {
      month = dateSplitted[0];
      day = dateSplitted[1];
      year = dateSplitted[2];
      return `${year}-${month}-${day}`;
    }
  }
}
